import { render, staticRenderFns } from "./RotateWorld.vue?vue&type=template&id=d4f8e1c0&scoped=true&"
import script from "./RotateWorld.vue?vue&type=script&lang=js&"
export * from "./RotateWorld.vue?vue&type=script&lang=js&"
import style0 from "./RotateWorld.vue?vue&type=style&index=0&id=d4f8e1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f8e1c0",
  null
  
)

export default component.exports